module.exports = __webpack_public_path__ + "static/media/futureEats.f3639c5e.gif";